<template>
	<div>
		<componentes
			:data="myData"
			:loadingtable="isLoading"
			:total-pages="totalPages"
			:currentpage="currentpage"
			@search-text="getFilterData($event)"
			@pagechange="getFilterData($event)"
			@apply-modal="getFilterData($event)"
		/>
	</div>
</template>

<script>
import componentes from '../../layout/components/table/componentes';
import * as ecAxios from '../../util/ecAxios';

export default {
	components: {
		componentes,
	},
	data() {
		return {
			data: [],
			isLoading: true,
			limit: 10,
			offset: 0,
			mytotalPages: 0,
			pagenumber: 0,
			totalPages: 0,
			currentpage: 1,
		};
	},
	computed: {
		myData() {
			return this.data;
		},
	},
	created() {
		this.getAllData({
			direction: 'desc',
			limit: this.limit,
			offset: 0,
			orderby: 'dt_inicio',
			searchTerm: '',
			dt_inicio: '',
			dt_fim: '',
		});
	},
	methods: {
		async getAllData() {
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_PRODUTOS_DESTAQUE}/showcomp`, {
					direction: 'desc',
					// limit: 50,
					offset: 0,
				})
				.then((response) => {
					if (response.data.error === 0) {
						this.totalPages = response.data.count;
						this.data = response.data.componentes;
						this.isLoading = false;
					}
				});
		},
		async getFilterData(data, pagenumber = 0) {
			this.currentpage = pagenumber;
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_PRODUTOS_DESTAQUE}/showcomp`, data)
				.then((response) => {
					if (response.data.error === 0) {
						this.totalPages = response.data.count;
						this.data = response.data.componentes;
						this.isLoading = false;
					}
				});
		},
	},
};
</script>

<style></style>

